import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from '../axios.jsx';
import { Modal, Button, Badge } from 'react-bootstrap';
import Swal from 'sweetalert2';
import EvaluacionRiesgo from './EvaluacionRiesgo.jsx';
import Select from 'react-select/creatable';

const URI_CIT = 'citar_sar/';
const URI_REU = 'reunion/';
const URI_AGE = 'agenda/';
const URI = 'codigo/';
const URI4 = 'sendmailSAR/'

// Ajusta esto si tu axios.jsx no expone baseURL directamente
const FILES_BASE_URL = (axios.defaults && axios.defaults.baseURL) || '';

// Configuración por tipo de sala. El mismo componente sirve para:
//   SARS: Sala de Análisis de Riesgo en Salud            (/sars/:codigo)
//   SARA: Sala de Análisis de Riesgo en Salud Ambiental  (/sara/:codigo)
const SALAS = {
  SARS: {
    sigla: 'SARS',
    nombre: 'Sala de Análisis de Riesgo en Salud',
    tituloAgenda: 'SALA DE ANALISIS DE RIESGO EN SALUD (SARS)',
    campoActiva: 'Activa_SAR',
    requiereEvaluacion: true,   // la conclusión exige evaluar el riesgo
  },
  SARA: {
    sigla: 'SARA',
    nombre: 'Sala de Análisis de Riesgo en Salud Ambiental',
    tituloAgenda: 'SALA DE ANALISIS DE RIESGO EN SALUD AMBIENTAL (SARA)',
    campoActiva: 'Activa_SARA',
    requiereEvaluacion: false,  // por ahora la SARA no requiere evaluación del riesgo
  },
};

const ViewSARS = ({ tipoSala = 'SARS' }) => {
  const { codigo } = useParams();
  const navigate = useNavigate();
  const sala = SALAS[tipoSala] || SALAS.SARS;

  const [citas, setCitas] = useState([]);
  const [reuniones, setReuniones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lugar, setlugar] = useState(null);

  const [viewItem, setViewItem] = useState(null);
  const [showViewCitas, setShowViewCitas] = useState(false);
  const [showViewReuniones, setShowViewReuniones] = useState(false);
  const [showEditCitas, setShowEditCitas] = useState(false);
  const [showEditReunion, setShowEditReunion] = useState(false);
  const [mostrarEvaluacion, setMostrarEvaluacion] = useState(false);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const tipo = params.get('tipo');
  const [isReunionModalVisible, setIsReunionModalVisible] = useState(false);

  const [showModalCita, setShowModalCita] = useState(false);
  const [showModalReunion, setShowModalReunion] = useState(false);

  // Re-citación: si es true, el modal de citación crea una nueva citación
  // sobre una sala que ya fue activada.
  const [esRecitacion, setEsRecitacion] = useState(false);
  // Citación a la que se le registra la conclusión (1 citación = 1 conclusión)
  const [citaTarget, setCitaTarget] = useState(null);

  // Modal dedicado para subir/reemplazar el PDF de una reunión puntual
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadTarget, setUploadTarget] = useState(null); // reunión sobre la que se sube el PDF
  const [uploadFile, setUploadFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [fechaCita, setFechaCita] = useState('');
  const [horaCita, setHoraCita] = useState('');
  const [horaCitafin, setHoraCitafin] = useState('');
  const [tema, setTema] = useState('');
  const [tituloSala, setTituloSala] = useState('');
  const [correoConsecutivo, setCorreoConsecutivo] = useState('');
  const [correos, setCorreos] = useState([]);
  const [participantesCita, setParticipantesCita] = useState([]);

  const [conclusion, setConclusion] = useState('');
  const [evaluacion, setEvaluacion] = useState('');
  const [nivel, setNivel] = useState('');
  const [respuesta, setRespuesta] = useState('');

  const [gestor, setGestor] = useState('');
  const [usernivel, setUsernivel] = useState('');

  const resetCitaFields = () => {
    setFechaCita('');
    setHoraCita('');
    setHoraCitafin('');
    setCorreoConsecutivo('');
    setParticipantesCita([]);
    setTema('');
    setTituloSala('');
    setlugar('');
  };

  const esEmailValido = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const resetReunionFields = () => {
    setConclusion('');
    setEvaluacion('');
    setNivel('');
    setRespuesta('');
  };

  const resetUploadFields = () => {
    setUploadTarget(null);
    setUploadFile(null);
    setUploading(false);
  };

  const getLocalDateString = (inputDate) => {
    const date = new Date(inputDate + 'T00:00:00');
    const offset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - offset);
    return date.toISOString().split('T')[0];
  };

  // NUEVO: ¿el usuario actual puede subir/reemplazar/eliminar el documento de esta reunión?
  // Reglas: si aún no hay documento, cualquier gestor puede cargarlo (se vuelve el dueño).
  // Si ya hay uno, solo el gestor que lo cargó (Gestor_Documento) o un admin (nivel 1) pueden tocarlo.
  const puedeGestionarDocumento = (reunion) => {
    if (!reunion) return false;
    if (usernivel === '1') return true;
    if (!reunion.Listado_Asistencia) return true;
    return reunion.Gestor_Documento === gestor;
  };

  useEffect(() => {
    const user = sessionStorage.getItem('username');
    const nivel = sessionStorage.getItem('usernivel');
    if (user) setGestor(user);
    if (nivel) setUsernivel(nivel);

    fetchData();
    axios.get('directorio/').then(res => {
      const opciones = res.data.map(c => ({ value: c.Correo, label: c.Correo }));
      setCorreos(opciones);
    });
  }, [codigo, tipoSala]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [resC, resR] = await Promise.all([
        axios.get(`${URI_CIT}${codigo}`, { params: { tipo: sala.sigla } }),
        axios.get(`${URI_REU}${codigo}`, { params: { tipo: sala.sigla } }),
      ]);
      const norm = data => Array.isArray(data) ? data : data ? [data] : [];
      setCitas(norm(resC.data));
      setReuniones(norm(resR.data));
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: 'error', title: 'Error al cargar datos' });
      setCitas([]);
      setReuniones([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCita = async (blog) => {
    if (usernivel === '1') {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción eliminará la cita permanentemente.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        try {
          // Se borra solo esta citación, su evento de agenda y su conclusión
          await axios.delete(`${URI_CIT}${blog.id}`);
          await axios.delete(`${URI_AGE}cita/${blog.id}`);
          await axios.delete(`${URI_REU}cita/${blog.id}`);
          // Si era la única citación, la sala queda desactivada en la alerta
          if (citas.length <= 1) {
            await axios.put(`sat/codigo/${codigo}`, { [sala.campoActiva]: "NO" });
          }
          Swal.fire('Eliminado', 'La cita fue eliminada correctamente.', 'success');
          fetchData(); // refresca la lista
        } catch (error) {
          Swal.fire('Error', 'No se pudo eliminar la cita.', 'error');
        }
      }
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Acción no permitida',
        text: 'Esta acción solo está permitida para administradores.',
      });
    }
  };

  const setEditReunionFields = (r) => {
    setConclusion(r.Conclusion);
  };

  const handleDeleteReunion = async (id) => {
    if (usernivel === '1') {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esto eliminará la reunión de forma permanente.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`${URI_REU}${id}`);
          Swal.fire('Eliminado', 'La reunión fue eliminada.', 'success');
          fetchData();
        } catch (error) {
          if (error.response && error.response.status === 403) {
            Swal.fire('Error', 'No tienes permiso para eliminar esta reunión.', 'error');
          } else {
            Swal.fire('Error', 'No se pudo eliminar la reunión.', 'error');
          }
        }
      }
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Acción no permitida',
        text: 'Esta acción solo está permitida para administradores.',
      });
    }
  };

  const evaluarRiesgo = () => {
    setShowModalReunion(false);
    setMostrarEvaluacion(true);
  };

  const onResultadosListos = ({ evaluacion, nivel, respuesta }) => {
    setEvaluacion(evaluacion);
    setNivel(nivel);
    setRespuesta(respuesta);
    setMostrarEvaluacion(false);
    setShowModalReunion(true);
  };

  // Abre el modal de subida para una reunión específica de la tabla (con validación de permisos)
  const abrirSubirListado = (reunion) => {
    if (!puedeGestionarDocumento(reunion)) {
      Swal.fire({
        icon: 'warning',
        title: 'Acción no permitida',
        text: 'Solo el gestor que cargó este documento o un administrador pueden modificarlo.',
      });
      return;
    }
    setUploadTarget(reunion);
    setUploadFile(null);
    setShowUploadModal(true);
  };

  // Sube (o reemplaza) el PDF de la reunión seleccionada
  const handleUploadListado = async () => {
    if (!uploadFile) {
      Swal.fire({ icon: 'warning', title: 'Selecciona un archivo PDF' });
      return;
    }
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('listadoAsistencia', uploadFile);
      // Identifican quién hace la petición, para que el backend valide permisos
      formData.append('solicitante', gestor);
      formData.append('usernivel', usernivel);

      await axios.put(`${URI_REU}${uploadTarget.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      Swal.fire({
        icon: 'success',
        title: 'Listado cargado',
        text: 'El PDF se guardó correctamente.',
        timer: 1800,
        showConfirmButton: false,
      });

      setShowUploadModal(false);
      resetUploadFields();
      fetchData();
    } catch (error) {
      if (error.response && error.response.status === 403) {
        Swal.fire('Acción no permitida', error.response.data?.message || 'No tienes permiso para modificar este documento.', 'error');
      } else {
        Swal.fire('Error', 'No se pudo subir el listado de asistencia', 'error');
      }
    } finally {
      setUploading(false);
    }
  };

  // NUEVO: elimina el listado de asistencia (registro + archivo físico), con confirmación y validación de permisos
  const handleDeleteListado = async (reunion) => {
    if (!puedeGestionarDocumento(reunion)) {
      Swal.fire({
        icon: 'warning',
        title: 'Acción no permitida',
        text: 'Solo el gestor que cargó este documento o un administrador pueden eliminarlo.',
      });
      return;
    }

    const result = await Swal.fire({
      title: '¿Eliminar listado de asistencia?',
      text: 'Se borrará el registro y el archivo PDF de forma permanente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (!result.isConfirmed) return;

    try {
      await axios.delete(`${URI_REU}${reunion.id}/listado`, {
        data: { solicitante: gestor, usernivel },
      });
      Swal.fire('Eliminado', 'El listado de asistencia fue eliminado.', 'success');
      fetchData();
    } catch (error) {
      if (error.response && error.response.status === 403) {
        Swal.fire('Acción no permitida', error.response.data?.message || 'No tienes permiso para eliminar este documento.', 'error');
      } else {
        Swal.fire('Error', 'No se pudo eliminar el listado de asistencia', 'error');
      }
    }
  };

  // ── Citaciones y conclusiones ──
  // Cada citación tiene su número (1 = primera, 2+ = re-citación) y UNA conclusión.
  const numeroCita = {};
  citas.forEach((c, i) => { numeroCita[c.id] = i + 1; });

  const conclusionPorCita = {};
  reuniones.forEach(r => {
    if (r.Id_Cita && !conclusionPorCita[r.Id_Cita]) conclusionPorCita[r.Id_Cita] = r;
  });

  const ultimaCita = citas.length ? citas[citas.length - 1] : null;

  const etiquetaCita = (c) => {
    const n = numeroCita[c?.id];
    if (!n) return '—';
    return n === 1 ? '1ª citación' : `Re-citación N° ${n}`;
  };

  // Sala independiente (SARS-I / SARA-I): su código empieza por SAR y lleva título propio
  const esIndependiente = String(codigo || '').startsWith('SAR');
  // Título vigente: el de la citación más reciente que lo tenga
  const tituloActual = [...citas].reverse().find(c => c.Titulo)?.Titulo || '';

  // Abre el modal para la primera citación o para volver a citar
  const abrirModalCita = (recitar) => {
    resetCitaFields();
    if (esIndependiente) setTituloSala(tituloActual);
    if (recitar) {
      // Se puede volver a citar en cualquier momento; cada citación conserva
      // su propia conclusión (se registra desde la tabla de citaciones).
      // Se precargan lugar, participantes y tema de la última citación
      if (ultimaCita) {
        setParticipantesCita((ultimaCita.Citados || '').split(',').map(e => e.trim()).filter(Boolean));
        setlugar(ultimaCita.Lugar ? { value: ultimaCita.Lugar, label: ultimaCita.Lugar } : null);
        setTema(ultimaCita.Tema || '');
      }
    }
    setEsRecitacion(recitar);
    setShowModalCita(true);
  };

  // Abre el modal de conclusión para una citación puntual
  const abrirConclusion = (cita) => {
    if (!cita) return;
    if (conclusionPorCita[cita.id]) {
      Swal.fire({
        icon: 'info',
        title: 'Conclusión ya registrada',
        text: `La ${etiquetaCita(cita).replace(/^./, ch => ch.toLowerCase())} ya tiene su conclusión. Para registrar otra, vuelva a citar la ${sala.sigla}.`,
      });
      return;
    }
    resetReunionFields();
    setCitaTarget(cita);
    setShowModalReunion(true);
  };

  // Payload para AGE (diferente estructura)
  const payloadAGE = {
    Codigo: codigo,
    Fecha: fechaCita,
    Hora_inicio: horaCita,
    Hora_fin: horaCitafin,
    Titulo: `${sala.tituloAgenda} ${codigo}`,
    Responsable: gestor,
  }

  const nivelBadgeVariant = (nivel) => {
    if (!nivel) return 'secondary';
    const n = nivel.toString().toLowerCase();
    if (n.includes('alto')) return 'danger';
    if (n.includes('medio')) return 'warning';
    if (n.includes('bajo')) return 'success';
    return 'secondary';
  };

  return (
    <div className="container mb-3 sars-container">
      {/* Estilos propios para tablas y modales */}
      <style>{`
        .sars-container h3 {
          font-weight: 700;
          color: #1f3a5f;
        }

        .sars-card {
          background: #fff;
          border-radius: 14px;
          box-shadow: 0 2px 14px rgba(0,0,0,0.08);
          padding: 1.25rem 1.25rem 0.5rem;
          margin-bottom: 1.75rem;
        }

        .sars-card-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }

        .sars-table-wrapper {
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e7ebf0;
        }

        .sars-table {
          margin-bottom: 0;
        }

        .sars-table thead th {
          background: linear-gradient(135deg, #1f3a5f, #2f5c93);
          color: #fff;
          border: none;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          padding: 0.85rem 0.9rem;
          vertical-align: middle;
        }

        .sars-table tbody td {
          padding: 0.75rem 0.9rem;
          vertical-align: middle;
          font-size: 0.92rem;
          border-color: #eef1f4;
        }

        .sars-table tbody tr:hover {
          background-color: #f4f8fc;
          transition: background-color 0.15s ease-in-out;
        }

        .sars-empty-row td {
          text-align: center;
          padding: 1.25rem;
          color: #8a94a6;
          font-style: italic;
        }

        .sars-action-btn {
          border-radius: 8px !important;
          margin: 0 2px;
        }

        .sars-listado-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          border-radius: 999px;
          font-size: 0.78rem;
          font-weight: 600;
        }

        .sars-listado-pill.pendiente {
          background: #fff4e5;
          color: #b15a00;
        }

        .sars-listado-pill.cargado {
          background: #e6f6ec;
          color: #1e7e42;
        }

        .sars-listado-pill.cita-primera {
          background: #e8f0fb;
          color: #1f3a5f;
        }
        .sars-listado-pill.cita-recitacion {
          background: #f3e8fb;
          color: #6a2c91;
        }
        .sars-listado-owner {
          font-size: 0.74rem;
          color: #8a94a6;
        }

        /* Modales */
        .modal-header.sars-header-cita {
          background: #1f3a5f;
          color: #fff;
        }
        .modal-header.sars-header-reunion {
          background: #2f5c93;
          color: #fff;
        }
        .modal-header.sars-header-upload {
          background: #1e7e42;
          color: #fff;
        }
        .modal-header.sars-header-cita .btn-close,
        .modal-header.sars-header-reunion .btn-close,
        .modal-header.sars-header-upload .btn-close {
          filter: invert(1) brightness(2);
        }

        .sars-modal-body .form-group {
          margin-bottom: 1rem;
        }

        .sars-modal-body label {
          font-weight: 600;
          color: #334155;
          font-size: 0.88rem;
          margin-bottom: 4px;
          display: block;
        }

        .sars-modal-body .form-control,
        .sars-modal-body textarea {
          border-radius: 8px;
          border: 1px solid #dbe2ea;
        }

        .sars-readonly-box {
          background: #f7f9fb;
        }

        .sars-file-drop {
          border: 2px dashed #b9c6d6;
          border-radius: 10px;
          padding: 1.5rem;
          text-align: center;
          background: #f9fbfd;
        }

        .sars-file-drop p {
          margin-bottom: 0.5rem;
          color: #5b6b82;
          font-size: 0.9rem;
        }
      `}</style>

      <h3>Activación {sala.nombre} ({sala.sigla}) de {codigo}</h3>
      {tituloActual && <p className="text-muted mb-3" style={{ fontSize: '1.05rem' }}>{tituloActual}</p>}

      {/* Tabla de Citas */}
      <div className="sars-card">
        <div className="sars-card-header">
          <h5 className="mb-0">Citaciones</h5>
          {citas.length === 0 ? (
            <Button variant="success" onClick={() => abrirModalCita(false)}>
              Activar {sala.sigla}
            </Button>
          ) : (
            <Button
              variant="success"
              onClick={() => abrirModalCita(true)}
              title={`Volver a citar la ${sala.sigla}`}
            >
              <i className="fas fa-redo"></i> Volver a citar
            </Button>
          )}
        </div>

        {loading ? <p>Cargando citas...</p> : (
          <div className="sars-table-wrapper">
            <table className="table table-striped sars-table">
              <thead>
                <tr>
                  <th>N°</th><th>Fecha Cita</th><th>Hora inicio</th><th>Hora final</th><th>Gestor</th><th>Conclusión</th><th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {citas.length ? citas.map(c => (
                  <tr key={c.id}>
                    <td>
                      <span className={`sars-listado-pill ${numeroCita[c.id] === 1 ? 'cita-primera' : 'cita-recitacion'}`}>
                        {etiquetaCita(c)}
                      </span>
                    </td>
                    <td>{c.Fecha}</td>
                    <td>{c.Hora_inicio}</td>
                    <td>{c.Hora_fin}</td>
                    <td>{c.Gestor}</td>
                    <td>
                      {conclusionPorCita[c.id] ? (
                        <span className="sars-listado-pill cargado">
                          <i className="fas fa-check-circle"></i> Registrada
                        </span>
                      ) : (
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <span className="sars-listado-pill pendiente">
                            <i className="fas fa-exclamation-circle"></i> Pendiente
                          </span>
                          <Button
                            variant="primary"
                            size="sm"
                            className="sars-action-btn"
                            onClick={() => abrirConclusion(c)}
                          >
                            <i className="fas fa-plus"></i> Registrar
                          </Button>
                        </div>
                      )}
                    </td>
                    <td>
                      <Button variant="info" size="sm" className="sars-action-btn" onClick={() => {
                        setViewItem(c);
                        setShowViewCitas(true);
                      }}>
                        <i className="fas fa-eye"></i>
                      </Button>
                      <Button
                        variant="warning"
                        size="sm"
                        className="sars-action-btn"
                        onClick={() => {
                          if (usernivel === '1') {
                            setViewItem(c);
                            setFechaCita(c.Fecha);
                            setHoraCita(c.Hora_inicio);
                            setHoraCitafin(c.Hora_fin);
                            setCorreoConsecutivo(c.Consecutivo);
                            setParticipantesCita((c.Citados || '').split(',').map(email => email.trim()).filter(Boolean));
                            setTema(c.Tema);
                            setShowEditCitas(true);
                          } else {
                            Swal.fire({
                              icon: 'warning',
                              title: 'Acción no permitida',
                              text: 'Esta acción solo está permitida para administradores.',
                            });
                          }
                        }}
                      >
                        <i className="fas fa-edit"></i>
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        className="sars-action-btn"
                        onClick={() => handleDeleteCita(c)}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                )) : (
                  <tr className="sars-empty-row"><td colSpan="7">No se ha activado la {sala.sigla}</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Tabla de Reuniones */}
      <div className="sars-card">
        <div className="sars-card-header">
          <h5 className="mb-0">Reuniones / Conclusiones</h5>
          <span className="text-muted small">Las conclusiones se registran desde la tabla de citaciones (botón <b>Registrar</b>).</span>
        </div>

        {loading ? <p>Cargando reuniones...</p> : (
          <div className="sars-table-wrapper">
            <table className="table table-striped sars-table">
              <thead>
                <tr>
                  <th>Citación</th>
                  <th>Fecha Reunión</th>
                  <th>Hora</th>
                  <th>Gestor</th>
                  {sala.requiereEvaluacion && <th>Nivel Riesgo</th>}
                  <th>Listado de Asistencia</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {reuniones.length ? reuniones.map(r => {
                  const puedeGestionar = puedeGestionarDocumento(r);
                  return (
                    <tr key={r.id}>
                      <td>
                        {numeroCita[r.Id_Cita]
                          ? <span className={`sars-listado-pill ${numeroCita[r.Id_Cita] === 1 ? 'cita-primera' : 'cita-recitacion'}`}>{etiquetaCita({ id: r.Id_Cita })}</span>
                          : <span className="text-muted">—</span>}
                      </td>
                      <td>{r.Fecha}</td>
                      <td>{r.Hora}</td>
                      <td>{r.Gestor}</td>
                      {sala.requiereEvaluacion && (
                        <td>
                          {r.Nivel_Riesgo
                            ? <Badge bg={nivelBadgeVariant(r.Nivel_Riesgo)}>{r.Nivel_Riesgo}</Badge>
                            : <span className="text-muted">—</span>}
                        </td>
                      )}
                      <td>
                        {r.Listado_Asistencia ? (
                          <div>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                              <span className="sars-listado-pill cargado">
                                <i className="fas fa-check-circle"></i> Cargado
                              </span>
                              <a
                                href={`${FILES_BASE_URL}uploads/reuniones/${r.Listado_Asistencia}`}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-sm sars-action-btn"
                              >
                                <i className="fas fa-file-pdf"></i> Ver PDF
                              </a>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                className="sars-action-btn"
                                onClick={() => abrirSubirListado(r)}
                                disabled={!puedeGestionar}
                                title={puedeGestionar ? 'Reemplazar PDF' : 'Solo quien lo cargó o un administrador puede reemplazarlo'}
                              >
                                <i className="fas fa-sync-alt"></i> Reemplazar
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                className="sars-action-btn"
                                onClick={() => handleDeleteListado(r)}
                                disabled={!puedeGestionar}
                                title={puedeGestionar ? 'Eliminar PDF' : 'Solo quien lo cargó o un administrador puede eliminarlo'}
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            </div>
                            {r.Gestor_Documento && (
                              <div className="sars-listado-owner mt-1">
                                Cargado por: <b>{r.Gestor_Documento}</b>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <span className="sars-listado-pill pendiente">
                              <i className="fas fa-exclamation-circle"></i> Pendiente
                            </span>
                            <Button
                              variant="warning"
                              size="sm"
                              className="sars-action-btn"
                              onClick={() => abrirSubirListado(r)}
                            >
                              <i className="fas fa-upload"></i> Subir PDF
                            </Button>
                          </div>
                        )}
                      </td>
                      <td>
                        <Button variant="info" size="sm" className="sars-action-btn" onClick={() => {
                          setViewItem(r);
                          setShowViewReuniones(true);
                        }}>
                          <i className="fas fa-eye"></i>
                        </Button>
                        <Button
                          variant="warning"
                          size="sm"
                          className="sars-action-btn"
                          onClick={() => {
                            if (usernivel === '1') {
                              setViewItem(r);
                              setEditReunionFields(r);
                              setShowEditReunion(true);
                            } else {
                              Swal.fire({
                                icon: 'warning',
                                title: 'Acción no permitida',
                                text: 'Esta acción solo está permitida para administradores.',
                              });
                            }
                          }}
                        >
                          <i className="fas fa-edit"></i>
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          className="sars-action-btn"
                          onClick={() => handleDeleteReunion(r.id)}
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }) : (
                  <tr className="sars-empty-row"><td colSpan={sala.requiereEvaluacion ? 7 : 6}>No hay reuniones registradas</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal Detalle Cita */}
      <Modal show={showViewCitas} onHide={() => {
        setShowViewCitas(false);
        setViewItem(null);
      }}>
        <Modal.Header closeButton className="sars-header-cita"><Modal.Title>Detalle de Cita</Modal.Title></Modal.Header>
        <Modal.Body className="sars-modal-body">
          {viewItem && (
            <>
              <p><strong>Código SAT:</strong> {viewItem.Codigo_SAT}</p>
              <p><strong>Citación:</strong> {etiquetaCita(viewItem)}</p>
              <p><strong>Fecha:</strong> {viewItem.Fecha}</p>
              <p><strong>Hora Inicio:</strong> {viewItem.Hora_inicio}</p>
              <p><strong>Hora Final:</strong> {viewItem.Hora_fin}</p>
              <p><strong>Lugar:</strong> {viewItem.Lugar}</p>
              <p><strong>Citados:</strong> {viewItem.Citados}</p>
              <p style={{ whiteSpace: 'pre-line' }}>
                <strong>Tema:</strong> {viewItem.Tema}</p>
              <p><strong>Gestor:</strong> {viewItem.Gestor}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={() => setShowViewCitas(false)}>Cerrar</Button></Modal.Footer>
      </Modal>

      {/* Modal Detalle Reunión */}
      <Modal show={showViewReuniones} onHide={() => {
        setShowViewReuniones(false);
        setViewItem(null);
      }}>
        <Modal.Header closeButton className="sars-header-reunion"><Modal.Title>Detalle de Reunión</Modal.Title></Modal.Header>
        <Modal.Body className="sars-modal-body">
          {viewItem && (
            <>
              <p><strong>Código SAT:</strong> {viewItem.Codigo_SAT}</p>
              <p><strong>Citación:</strong> {etiquetaCita({ id: viewItem.Id_Cita })}</p>
              <p><strong>Fecha:</strong> {viewItem.Fecha}</p>
              <p><strong>Hora:</strong> {viewItem.Hora}</p>
              <p>
                <strong>Listado de asistencia:</strong>{' '}
                {viewItem.Listado_Asistencia ? (
                  <a
                    href={`${FILES_BASE_URL}uploads/reuniones/${viewItem.Listado_Asistencia}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver PDF
                  </a>
                ) : 'No adjunto'}
              </p>
              {viewItem.Gestor_Documento && (
                <p><strong>Cargado por:</strong> {viewItem.Gestor_Documento}</p>
              )}
              {sala.requiereEvaluacion && (
                <>
                  <p><strong>Puntaje:</strong> {viewItem.Puntaje}</p>
                  <p><strong>Nivel de Riesgo:</strong> {viewItem.Nivel_Riesgo}</p>
                  <p><strong>Respuesta:</strong> {viewItem.Respuesta}</p>
                </>
              )}
              <p style={{ whiteSpace: 'pre-line' }}><strong>Conclusión:</strong> {viewItem.Conclusion}</p>
              <p><strong>Gestor:</strong> {viewItem.Gestor}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={() => setShowViewReuniones(false)}>Cerrar</Button></Modal.Footer>
      </Modal>

      {/* Modal Activar Cita */}
      <Modal show={showModalCita} onHide={() => {
        setShowModalCita(false);
        setEsRecitacion(false);
        resetCitaFields();
      }}>
        <Modal.Header closeButton className="sars-header-cita">
          <Modal.Title>
            {esRecitacion
              ? `Volver a citar ${sala.sigla} — Re-citación N° ${citas.length + 1}`
              : `Activar ${sala.sigla}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="sars-modal-body">
          {esIndependiente && (
            <div className="form-group">
              <label>Título: <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={tituloSala}
                onChange={e => setTituloSala(e.target.value)}
                placeholder="Título de la sala"
                maxLength={200}
              />
              <small className="text-muted">Aparece en el asunto del correo de citación.</small>
            </div>
          )}
          <div className="form-group">
            <label>Fecha:</label>
            <input type="date" className="form-control" value={fechaCita} onChange={e => setFechaCita(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Hora Inicio:</label>
            <input type="time" className="form-control" value={horaCita} onChange={e => setHoraCita(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Hora Fin:</label>
            <input type="time" className="form-control" value={horaCitafin} onChange={e => setHoraCitafin(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Lugar:</label>
            <Select
              options={[
                {
                  value: "OFICINA VIGILANCIA EN SALUD PUBLICA",
                  label: "OFICINA VIGILANCIA EN SALUD PUBLICA"
                },
                {
                  value: "MALOKA - SECRETARIA DE SALUD DEPARTAMENTAL",
                  label: "MALOKA - SECRETARIA DE SALUD DEPARTAMENTAL"
                },
                {
                  value: "OFICINA PAI DEPARTAMENTAL",
                  label: "OFICINA PAI DEPARTAMENTAL"
                },
              ]}
              value={lugar}
              onChange={(selected) => setlugar(selected)}
              placeholder="Seleccione o escriba un lugar"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 })
              }}
            />
          </div>

          <div className="form-group">
            <label>Consecutivo de Correo:</label>
            <input type="text" className="form-control" value={correoConsecutivo} onChange={e => setCorreoConsecutivo(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Participantes:</label>
            <Select
              isMulti
              options={correos}
              value={participantesCita.map(e => ({
                value: e,
                label: e
              }))}
              placeholder="Selecciona o escribe correos..."
              formatCreateLabel={(input) => `Agregar "${input}"`}
              onChange={(selected) => {
                if (!selected) {
                  setParticipantesCita([]);
                  return;
                }
                let lista = selected.map(s => s.value.trim());
                lista = [...new Set(lista)];
                setParticipantesCita(lista);
              }}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                option: (base, state) => ({
                  ...base,
                  color: esEmailValido(state.data.value) ? "black" : "red"
                }),
                multiValueLabel: (base, state) => ({
                  ...base,
                  color: esEmailValido(state.data.value) ? "black" : "red"
                })
              }}
            />
            <p className="mt-2">
              Correos seleccionados: <b>{participantesCita.length}</b>
            </p>
          </div>
          <div className="form-group">
            <label>Tema a tratar:</label>
            <textarea className="form-control" value={tema} onChange={e => setTema(e.target.value)}></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModalCita(false);
            setEsRecitacion(false);
            resetCitaFields();
          }}>Cancelar</Button>
          <Button variant="success" onClick={async () => {
            if (esIndependiente && !tituloSala.trim()) {
              alert("Escribe el título de la sala: aparece en el asunto del correo");
              return;
            }
            if (participantesCita.length === 0) {
              alert("Por favor selecciona al menos un participante");
              return;
            }
            if (!fechaCita || !horaCita || !horaCitafin || !correoConsecutivo || !tema) {
              alert("Todos los campos son requeridos");
              return;
            }
            Swal.fire({
              title: 'Guardando información...',
              text: 'Por favor espera un momento',
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            try {
              const { data: nueva } = await axios.post(URI_CIT, {
                Codigo_SAT: codigo,
                Fecha: fechaCita,
                Hora_inicio: horaCita,
                Hora_fin: horaCitafin,
                Consecutivo: correoConsecutivo,
                Citados: participantesCita.join(', '),
                Lugar: lugar?.value || "",
                Tema: tema,
                Gestor: gestor,
                Tipo_Sala: sala.sigla,
                // Sala independiente: título del modal (precargado con el vigente)
                Titulo: esIndependiente ? tituloSala.trim() : undefined,
              });
              if (!nueva?.id) throw new Error(nueva?.message || 'No se creó la citación');
              await axios.put(`sat/codigo/${codigo}`, { [sala.campoActiva]: "SI" });
              await axios.post(URI_AGE, { ...payloadAGE, Id_Cita: nueva.id });
              await axios.get(URI4, {
                params: { codigo: codigo, id: nueva.id, emails: participantesCita.join(', ') },
              });
              Swal.fire({
                icon: 'success',
                title: nueva.numero > 1 ? `Re-citación N° ${nueva.numero} enviada` : 'Guardado exitoso',
                text: 'La información se ha guardado correctamente.',
                timer: 2000,
                showConfirmButton: false,
              });
              setShowModalCita(false);
              setEsRecitacion(false);
              resetCitaFields();
              fetchData();
            } catch (error) {
              Swal.fire('Error', `No se pudo ${esRecitacion ? 'volver a citar' : 'activar'} la ${sala.sigla}`, 'error');
              console.error(error);
            }
          }}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Editar Cita */}
      <Modal
        show={showEditCitas}
        onHide={() => {
          setShowEditCitas(false);
          resetCitaFields();
        }}
      >
        <Modal.Header closeButton className="sars-header-cita">
          <Modal.Title>Editar citación {sala.sigla}{viewItem ? ` — ${etiquetaCita(viewItem)}` : ''}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="sars-modal-body">
          <div className="form-group">
            <label>Fecha:</label>
            <input
              type="date"
              className="form-control"
              value={fechaCita}
              onChange={e => setFechaCita(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Hora inicio:</label>
            <input
              type="time"
              className="form-control"
              value={horaCita}
              onChange={e => setHoraCita(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Hora final:</label>
            <input
              type="time"
              className="form-control"
              value={horaCitafin}
              onChange={e => setHoraCitafin(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Consecutivo de Correo:</label>
            <input
              type="text"
              className="form-control"
              value={correoConsecutivo}
              onChange={e => setCorreoConsecutivo(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Participantes:</label>
            <Select
              isMulti
              options={correos}
              value={correos.filter(c => participantesCita.includes(c.value))}
              onChange={selected => setParticipantesCita(selected.map(s => s.value))}
              classNamePrefix="select"
              placeholder="Selecciona participantes..."
            />
          </div>
          <div className="form-group">
            <label>Tema a tratar:</label>
            <textarea
              className="form-control"
              value={tema}
              onChange={e => setTema(e.target.value)}
            ></textarea>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowEditCitas(false);
              resetCitaFields();
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="success"
            onClick={async () => {
              try {
                await axios.put(`${URI_CIT}${viewItem.id}`, {
                  Codigo_SAT: codigo,
                  Fecha: fechaCita,
                  Hora_inicio: horaCita,
                  Hora_fin: horaCitafin,
                  Consecutivo: correoConsecutivo,
                  Citados: participantesCita.join(', '),
                  Tema: tema,
                  Gestor: gestor,
                });

                // Actualiza solo el evento de agenda de ESTA citación
                await axios.put(`${URI_AGE}cita/${viewItem.id}`, {
                  Codigo: codigo,
                  Fecha: fechaCita,
                  Hora_inicio: horaCita,
                  Hora_fin: horaCitafin,
                  Titulo: `${sala.tituloAgenda} ${codigo}`,
                  Responsable: gestor,
                });

                Swal.fire('Éxito', 'Cita actualizada correctamente', 'success');
                setShowEditCitas(false);
                resetCitaFields();
                fetchData();
              } catch (error) {
                console.error(error);
                Swal.fire('Error', 'No se pudo actualizar la cita', 'error');
              }
            }}
          >
            Guardar Cambios
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Crear Reunión (sin carga de PDF) */}
      <Modal
        show={showModalReunion}
        onHide={() => setShowModalReunion(false)}
      >
        <Modal.Header closeButton className="sars-header-reunion"><Modal.Title>Conclusión {sala.sigla}</Modal.Title></Modal.Header>
        <Modal.Body className="sars-modal-body">
          {citaTarget && (
            <p className="text-muted mb-3">
              Conclusión de la <b>{etiquetaCita(citaTarget).replace(/^./, ch => ch.toLowerCase())}</b> del <b>{citaTarget.Fecha}</b> ({citaTarget.Hora_inicio})
            </p>
          )}
          {sala.requiereEvaluacion && (
            <>
              <div className="row g-3">
                <div className="col-md-6">
                  <label>Evaluación del riesgo</label>
                  <input className="form-control sars-readonly-box" value={evaluacion} readOnly />
                </div>
                <div className="col-md-6">
                  <label>Nivel del riesgo</label>
                  <input type="text" className="form-control sars-readonly-box" value={nivel} readOnly />
                </div>
              </div>
              <label className="mt-3">Respuesta</label>
              <input type="text" className="form-control sars-readonly-box mb-3" value={respuesta} readOnly />

              <div className="text-center mb-3">
                <button onClick={evaluarRiesgo} className="btn btn-primary">
                  Evaluar Riesgo
                </button>
              </div>
            </>
          )}

          <div className="form-group">
            <label>Conclusiones:</label>
            <textarea className="form-control" value={conclusion} onChange={e => setConclusion(e.target.value)}></textarea>
          </div>

          <p className="text-muted small mb-0">
            El listado de asistencia se sube después de guardar, desde el botón <b>"Subir PDF"</b> en la tabla de Reuniones.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModalReunion(false);
            setCitaTarget(null);
            resetReunionFields();
          }}>Cancelar</Button>
          <Button variant="primary" onClick={async () => {
            const now = new Date();
            const fecha = getLocalDateString(now.toISOString().slice(0, 10));
            const hora = now.toTimeString().slice(0, 5);

            if (!conclusion) {
              alert("Todos los campos son requeridos");
              return;
            }
            if (sala.requiereEvaluacion && !evaluacion) {
              alert("Debe evaluar el riesgo");
              return;
            }
            if (!citaTarget) {
              alert("Seleccione la citación a la que corresponde la conclusión");
              return;
            }
            try {
              await axios.post(URI_REU, {
                Codigo_SAT: codigo,
                Id_Cita: citaTarget.id,
                Tipo_Sala: sala.sigla,
                Fecha: fecha,
                Hora: hora,
                Conclusion: conclusion,
                Gestor: gestor,
                // La SARA no lleva evaluación del riesgo (por ahora)
                Puntaje: sala.requiereEvaluacion ? evaluacion : null,
                Nivel_Riesgo: sala.requiereEvaluacion ? nivel : null,
                Respuesta: sala.requiereEvaluacion ? respuesta : null,
              });
              Swal.fire({
                icon: 'success',
                title: 'Reunión registrada',
                text: 'Ahora puedes subir el listado de asistencia desde la tabla.',
              });
              setShowModalReunion(false);
              setCitaTarget(null);
              resetReunionFields();
              fetchData();
            } catch (error) {
              if (error.response?.status === 409) {
                Swal.fire('Acción no permitida', error.response.data?.message || 'Esta citación ya tiene conclusión.', 'warning');
              } else {
                Swal.fire('Error', 'No se pudo registrar la reunión', 'error');
              }
            }
          }}>Guardar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Editar Reunión (sin carga de PDF) */}
      <Modal show={showEditReunion} onHide={() => {
        setShowEditReunion(false);
        resetReunionFields();
      }}>
        <Modal.Header closeButton className="sars-header-reunion">
          <Modal.Title>Editar Reunión</Modal.Title>
        </Modal.Header>
        <Modal.Body className="sars-modal-body">
          {sala.requiereEvaluacion && (
            <>
              <div className="row g-3">
                <div className="col-md-6">
                  <label>Evaluación del riesgo</label>
                  <input className="form-control sars-readonly-box" value={evaluacion} readOnly />
                </div>
                <div className="col-md-6">
                  <label>Nivel del riesgo</label>
                  <input type="text" className="form-control sars-readonly-box" value={nivel} readOnly />
                </div>
              </div>
              <label className="mt-3">Respuesta</label>
              <input type="text" className="form-control sars-readonly-box mb-3" value={respuesta} readOnly />

              <div className="text-center mb-3">
                <button onClick={evaluarRiesgo} className="btn btn-primary">
                  Evaluar Riesgo
                </button>
              </div>
            </>
          )}

          <div className="form-group">
            <label>Conclusiones:</label>
            <textarea
              className="form-control"
              value={conclusion}
              onChange={e => setConclusion(e.target.value)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowEditReunion(false);
              resetReunionFields();
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              try {
                await axios.put(`${URI_REU}${viewItem.id}`, {
                  Codigo_SAT: codigo,
                  Fecha: viewItem.Fecha,
                  Hora: viewItem.Hora,
                  Conclusion: conclusion,
                  Gestor: gestor,
                });
                Swal.fire('Actualizado', 'Reunión actualizada correctamente', 'success');
                setShowEditReunion(false);
                resetReunionFields();
                fetchData();
              } catch (error) {
                Swal.fire('Error', 'No se pudo actualizar la reunión', 'error');
              }
            }}
          >
            Guardar Cambios
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal dedicado para subir/reemplazar el listado de asistencia */}
      <Modal show={showUploadModal} onHide={() => {
        setShowUploadModal(false);
        resetUploadFields();
      }}>
        <Modal.Header closeButton className="sars-header-upload">
          <Modal.Title>Listado de Asistencia</Modal.Title>
        </Modal.Header>
        <Modal.Body className="sars-modal-body">
          {uploadTarget && (
            <p className="text-muted mb-3">
              Reunión del <b>{uploadTarget.Fecha}</b> a las <b>{uploadTarget.Hora}</b>
            </p>
          )}
          <div className="sars-file-drop">
            <i className="fas fa-file-pdf fa-2x mb-2" style={{ color: '#1e7e42' }}></i>
            <p>Selecciona el PDF con el listado de asistencia de la reunión</p>
            <input
              type="file"
              accept="application/pdf"
              className="form-control"
              onChange={(e) => setUploadFile(e.target.files[0] || null)}
            />
            {uploadFile && (
              <p className="mt-2 mb-0 text-success">
                <i className="fas fa-check-circle"></i> {uploadFile.name}
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowUploadModal(false);
            resetUploadFields();
          }}>Cancelar</Button>
          <Button variant="success" disabled={uploading} onClick={handleUploadListado}>
            {uploading ? 'Subiendo...' : 'Subir Listado'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Button variant="secondary" onClick={() => navigate(-1)}>Volver</Button>
      {mostrarEvaluacion && (
        <EvaluacionRiesgo
          onClose={() => setMostrarEvaluacion(false)}
          onResultadosListos={onResultadosListos}
        />
      )}
    </div>
  );
};

export default ViewSARS;